const UNIDADES = ["Kilogramos", "Toneladas", "Metros Cúbicos", "Litros"];

export default UNIDADES;
